const video = () => {
	if ($('.videoJs')[0]) {
		$('.videoJs')
			.parent()
			.click(function() {
				if (
					$(this)
						.children('.videoJs')
						.get(0).paused
				) {
					// Play
					$(this)
						.children('.playPause')
						.fadeOut()

					$(this)
						.children('.videoJs')
						.css('visibility', 'visible')
						.css('filter', 'brightness(1)')
						.get(0)
						.play()
				} else {
					// Pause
					$(this)
						.children('.playPause')
						.fadeIn()

					$(this)
						.children('.videoJs')
						.css('filter', 'brightness(0.5)')
						.get(0)
						.pause()
				}
			})
	}
}

export { video }
